module.exports = __webpack_public_path__ + "media/images/sp/top/keyword_waso_yoso@3x-f8069a652f5183e993009681f2badfc8.webp";